import { useState } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

function AddStaff({ addStaff, allRoles }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    notes: '',
    username: '',
    policecheck: false,
    dsl: false,
    firstaid: false,
    roles: []
  });

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = () => {
    addStaff(form);
    handleClose();
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleRolesChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({
      ...prev,
      roles: typeof value === 'string' ? value.split(',') : value
    }));
  };

  return (
    <div>
      <IconButton onClick={handleClickOpen}>
        <AddIcon color="primary" />
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>New Staff</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
                label="Username"
                name="username"
                variant="standard"
                fullWidth
                value={form.username}
                onChange={handleChange}
              />
              <TextField
                label="Notes"
                name="notes"
                variant="standard"
                fullWidth
                value={form.notes}
                onChange={handleChange}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.policecheck}
                    onChange={handleCheckboxChange}
                    name="policecheck"
                    color="primary"
                  />
                }
                label="Police Check Completed"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.dsl}
                    onChange={handleCheckboxChange}
                    name="dsl"
                    color="primary"
                  />
                }
                label="DSL Trained"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.firstaid}
                    onChange={handleCheckboxChange}
                    name="firstaid"
                    color="primary"
                  />
                }
                label="First Aid Qualified"
              />

              <InputLabel id="roles-label">Roles</InputLabel>
              <Select
                labelId="roles-label"
                multiple
                fullWidth
                value={form.roles}
                onChange={handleRolesChange}
                renderValue={(selected) => selected.join(', ')}
              >
                {allRoles.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role
                      .toLowerCase()
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddStaff;
